"use client";

import Link from "next/link";
import { Bell, CircleDot } from "lucide-react";
import { usePathname } from "next/navigation";
import { useDayOut } from "@/app/_components/companion/DayOutSelection";
import { withDayOut } from "@/lib/companion/day-out";
import { useShallowSearchParam } from "@/lib/hooks/use-shallow-search-param";
import { companionDestinationForPathname } from "@/lib/companion/navigation";
import { CompanionNavigation } from "./CompanionNavigation";
import { useActiveRecording } from "@/app/_components/companion/RecordingHost";

export function CompanionFrame() {
  const pathname = usePathname();
  const base = useShallowSearchParam("base");
  const demo = useShallowSearchParam("demo");
  const fixture = useShallowSearchParam("demo-e");
  const { selection } = useDayOut();
  const recording = useActiveRecording();
  const trackHref = recording.active ? recording.returnHref : withDayOut(`/companion/track${base ? `?${new URLSearchParams({ base })}` : ""}`, selection);
  return <header className="bg-navy text-white">
    <div className="mx-auto max-w-[1160px] px-4 md:px-10">
      <div className="flex min-h-14 items-center justify-between gap-3 md:min-h-16">
        <Link href="/companion" className="inline-flex min-h-11 items-center font-heading text-lg font-bold text-white no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light">Companion</Link>
        <div className="flex items-center gap-2">
          <Link href={trackHref} className="inline-flex min-h-11 items-center gap-2 rounded-full bg-teal px-4 text-sm font-semibold text-white no-underline hover:bg-teal-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light"><CircleDot size={17} aria-hidden="true" />{recording.active ? "Resume" : "Track"}</Link>
          <Link href="/companion/notifications" aria-label="Companion notifications" className="inline-flex size-11 items-center justify-center rounded-full border border-white/25 text-white hover:border-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light"><Bell size={19} aria-hidden="true" /></Link>
        </div>
      </div>
      <CompanionNavigation activeDestination={companionDestinationForPathname(pathname) ?? "today"} viewedBaseId={base} analyticsEnabled={!demo && !fixture} />
    </div>
  </header>;
}
